import { z } from 'zod';
import { IdSchema, ListQuerySchema, PageInfoSchema, TimestampSchema } from './common.js';
export const DocumentTargetTypeSchema = z.enum([
    'company',
    'contact',
    'lead',
    'opportunity',
    'project',
    'task',
]);
export const DocumentStatusSchema = z.enum([
    'pending_upload',
    'quarantined',
    'available',
    'rejected',
]);
export const DocumentSchema = z.strictObject({
    id: IdSchema,
    organizationId: IdSchema,
    targetType: DocumentTargetTypeSchema,
    targetId: IdSchema,
    fileName: z.string(),
    mimeType: z.string(),
    sizeBytes: z.number().int().nonnegative(),
    status: DocumentStatusSchema,
    uploadedByMembershipId: IdSchema,
    createdAt: TimestampSchema,
    updatedAt: TimestampSchema,
});
export const CreateDocumentUploadRequestSchema = z.strictObject({
    targetType: DocumentTargetTypeSchema,
    targetId: IdSchema,
    fileName: z.string().trim().min(1).max(255),
    mimeType: z.string().trim().min(1).max(150),
    sizeBytes: z
        .number()
        .int()
        .positive()
        .max(25 * 1024 * 1024),
});
export const DocumentUploadInstructionSchema = z.strictObject({
    document: DocumentSchema,
    method: z.literal('PUT'),
    uploadUrl: z.url(),
    expiresAt: TimestampSchema,
    requiredHeaders: z.record(z.string(), z.string()),
});
export const CompleteDocumentUploadRequestSchema = z.strictObject({
    checksumSha256: z.string().regex(/^[a-f0-9]{64}$/),
});
export const DocumentListQuerySchema = ListQuerySchema.extend({
    targetType: DocumentTargetTypeSchema.optional(),
    targetId: IdSchema.optional(),
});
export const DocumentDownloadSchema = z.strictObject({
    url: z.url(),
    expiresAt: TimestampSchema,
});
export const DocumentListSchema = z.strictObject({
    items: z.array(DocumentSchema),
    page: PageInfoSchema,
});
